// HomePage.tsx
import React, { useState } from "react";
import Layout from "../../layout/Layout";
import BlogArticle from "./BlogArticle";
// import Footer from "../header/Footer";
import { motion } from "framer-motion";
import { FaArrowLeft, FaArrowRight, FaStar } from "react-icons/fa";

const HomePage = () => {
  const destinations = [
    {
      name: "Down South",
      image: "/2182.jpg", // Replace with actual image URL
      tours: 356,
      activities: 248,
      promotion: 26, // Percentage of promotion left
      countdown: { days: 22, hours: 9, mins: 45, secs: 58 },
    },
    {
      name: "Badulla Srilanka",
      image: "/1161.jpg", // Replace with actual image URL
      tours: 356,
      activities: 248,
      promotion: 15,
      countdown: { days: 12, hours: 5, mins: 20, secs: 10 },
    },
    {
      name: "sigiriya Srilanka",
      image: "/461.jpg", // Replace with actual image URL
      tours: 356,
      activities: 248,
      promotion: 18,
      countdown: { days: 10, hours: 4, mins: 30, secs: 5 },
    },
    {
      name: "Gall Srilanka",
      image: "/22612.jpg", // Replace with actual image URL
      tours: 356,
      activities: 248,
      promotion: 5,
      countdown: { days: 4, hours: 3, mins: 21, secs: 12 },
    },
    {
      name: "Matara Srilanka",
      image: "/22612.jpg", // Replace with actual image URL
      tours: 356,
      activities: 248,
      promotion: 30,
      countdown: { days: 5, hours: 8, mins: 13, secs: 45 },
    },
  ];
  const testimonials = [
    {
      id: 1,
      name: "Sara Mohamed",
      location: "Jakarta",
      rating: 5,
      image: "https://placehold.co/100x100", // Replace with a real image URL
      text: "I've been using the hotel booking system for several years now, and it's become my go-to platform for planning my trips. The interface is user-friendly, and I appreciate the detailed information and real-time availability of hotels.",
    },
    {
      id: 2,
      name: "Atend John",
      location: "California",
      rating: 4,
      image: "https://placehold.co/100x100", // Replace with a real image URL
      text: "I had a last-minute business trip, and the system came to the rescue. I was able to book a hotel in no time and even got a great deal. The confirmation process was straightforward, and I received the necessary information promptly.",
    },
    {
      id: 3,
      name: "Emily Chen",
      location: "London",
      rating: 5,
      image: "https://placehold.co/100x100", // Replace with a real image URL
      text: "The support team is exceptional! I had a minor issue with my booking, and they resolved it quickly and efficiently. Their dedication to customer satisfaction is truly commendable.",
    },
    {
      id: 4,
      name: "David Lee",
      location: "New York",
      rating: 5,
      image: "https://placehold.co/100x100", // Replace with a real image URL
      text: "I highly recommend this platform to anyone looking for a seamless hotel booking experience. The user reviews and ratings are incredibly helpful in making informed decisions.",
    },
  ];

  const reviewsData = [
    {
      title: "Air Purifying Plants",
      description:
        "Amet minim mollit non deserunt ullamco aliqua dolor do amet sint Duis enim.",
    },
    {
      title: "Refreshing Plants",
      description:
        "Amet minim mollit non deserunt ullamco aliqua dolor do amet sint Duis enim.",
    },
    {
      title: "Plants For Home",
      description:
        "Amet minim mollit non deserunt ullamco aliqua dolor do amet sint Duis enim.",
    },
    {
      title: "Plants For Garden",
      description:
        "Amet minim mollit non deserunt ullamco aliqua dolor do amet sint Duis enim.",
    },
    {
      title: "Plants For Offices",
      description:
        "Amet minim mollit non deserunt ullamco aliqua dolor do amet sint Duis enim.",
    },
    {
      title: "Save Forests",
      description:
        "Amet minim mollit non deserunt ullamco aliqua dolor do amet sint Duis enim.",
    },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <Layout>
      <div
        className="relative w-full min-h-[60vh] md:min-h-screen bg-cover bg-center pt-24 flex items-center justify-center"
        style={{ backgroundImage: "url('/welcome-to-dalu-1.png')" }}
      >
        {/* Overlay below Navbar */}
        <div className="absolute inset-0 bg-black/50"></div>
        {/* Hero Section Content */}
        <div className="relative z-10 text-center text-white px-4 md:px-10 w-full">
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="text-3xl sm:text-4xl md:text-[55px] font-extrabold leading-tight"
          >
            Discover the Beauty of <br className="hidden md:block" />{" "}
            Sustainable Travel
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
            className="mt-4 text-base sm:text-lg md:text-xl"
          >
            Join us on a journey that respects nature and cultures. Explore
            eco-friendly destinations that inspire sustainable adventures.
          </motion.p>
          <motion.div
            className="mt-8 flex flex-col sm:flex-row sm:space-x-6 space-y-4 sm:space-y-0 items-center justify-center"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 1, ease: "easeOut" }}
          >
            <button className="bg-white text-black px-6 py-3 rounded-lg cursor-pointer transition-transform duration-300 ease-in-out transform hover:-translate-y-2 hover:shadow-lg w-full sm:w-auto">
              Explore
            </button>
            <button className="border-2 border-white text-white px-6 py-3 rounded-lg hover:bg-white hover:text-gray-900 cursor-pointer transition-transform duration-300 ease-in-out transform hover:-translate-y-2 hover:shadow-lg w-full sm:w-auto">
              Learn More
            </button>
          </motion.div>
        </div>
      </div>
      <div
        className="py-10 px-4 md:px-10 relative"
        style={{
          background:
            "linear-gradient(to bottom, rgb(4, 20, 2) 75%, white 25%)",
        }}
      >
        {/* Discover Section Header */}
        <motion.div
          className="mb-12 text-center"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-extra bold text-white">
            Discover Our Sustainable Travel Features
          </h2>
          <p className="mt-4 text-lg text-gray-300">
           Travel with purpose and make every journey count. Explore how your adventures can protect the planet,
empower communities, and create meaningful memories — one step at a time.
          </p>
        </motion.div>

        {/* Features Section */}
        <div className="flex flex-col md:flex-row justify-center gap-8 flex-wrap">
          {[
            {
              img: "/Eco friendly destinations.jpg",
              title: "Eco-Friendly Destinations for Conscious Travelers",
              desc: "Explore breathtaking destinations that prioritize environmental preservation and cultural respect. From pristine beaches to untouched forests, discover places that welcome travelers who care about sustainability andharmony with nature.",
              custom: 0,
              rounded: "rounded-tr-[50px]",
            },
            {
              img: "/sustainable travel tips.jpg",
              title: "Sustainable Travel Tips for Every Adventurer",
              desc: "Learn how to make your journeys greener — from packing reusable essentials to supporting local businesses. Our expert tips help you travel responsibly while still embracing adventure, comfort, and unforgettable experiences.",
              custom: 0.2,
              rounded: "rounded-lg",
            },
            {
              img: "/22612.jpg",
              title: "Community Impact Stories That Inspire Change",
              desc: "Meet the local heroes making a difference. Read stories of communities thriving through eco-tourism, conservation projects, and cultural exchange — showing how small actions can lead to global change.",
              custom: 0.4,
              rounded: "rounded-tl-[50px]",
            },
          ].map((feature, i) => (
            <motion.div
              key={i}
              className={`max-w-xs bg-white ${feature.rounded} shadow-lg overflow-hidden`}
              initial={{ opacity: 0, y: 50, scale: 0.9 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.7, delay: feature.custom }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <img
                src={feature.img}
                alt={feature.title}
                className="w-full h-56 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-black">
                  {feature.title}
                </h3>
                <p className="mt-2 text-gray-700">{feature.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="py-10 px-4 md:px-10 bg-white overflow-hidden">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Left Image */}
          <motion.div
            className="w-full md:w-1/2 relative mb-8 md:mb-0"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <img
              src="/Trail.jpg"
              alt="Travel Image"
              className="object-cover w-full h-full rounded-lg shadow-lg"
            />
            <div className="absolute top-0 left-0 w-full h-full bg-black opacity-20 rounded-lg"></div>
          </motion.div>

          {/* Right Content */}
          <motion.div
            className="w-full md:w-1/2 md:pl-10 font-[Roboto]"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-5xl font-extrabold text-gray-800">Trail</h2>
            <p className="mt-4 text-base font-semibold text-gray-600">
             Turn your travels into meaningful journeys. Trail helps you explore the world responsibly — with curated
experiences, sustainable stays, and eco-conscious adventures that leave a positive impact wherever you go.
            </p>

            {/* Features List */}
            <motion.div
              className="mt-10 space-y-8"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={{
                hidden: {},
                visible: {
                  transition: {
                    staggerChildren: 0.3, // stagger effect
                  },
                },
              }}
            >
              {[
                {
                  title: "Customized Itineraries for Sustainable Journeys",
                  desc: "Plan your perfect eco-friendly getaway with itineraries designed around green destinations, local culture, and minimal carbon footprints. Every route is crafted to help you travel smarter and sustain the beauty of our planet.",
                  icon: (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                    />
                  ),
                },
                {
                  title: "Guided Eco-Tours for Nature Lovers",
                  desc: "Join passionate guides who know the land, its people, and its hidden wonders. Discover breathtaking landscapes, unique wildlife, and local traditions — all while supporting conservation and community-driven tourism.",
                  icon: (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
                    />
                  ),
                },
                {
                  title: "Sustainable Accommodations for Responsible Travelers",
                  desc: "Stay in places that care for the environment as much as you do. From solar-powered lodges to locally owned guesthouses, each stay ensures comfort, authenticity, and a greener tomorrow.",
                  icon: (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 
                       1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 
                       3.75h16.5a1.5 1.5 0 0 0 
                       1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 
                       1.5 0 0 0 2.25 6v12a1.5 
                       1.5 0 0 0 1.5 1.5Z"
                    />
                  ),
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  className="flex items-start space-x-4"
                  variants={{
                    hidden: { opacity: 0, y: 40 },
                    visible: { opacity: 1, y: 0 },
                  }}
                  transition={{ duration: 0.8 }}
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-400 text-gray-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      {item.icon}
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-500">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            {/* Button */}
            <motion.div
              className="mt-10"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <button className="px-6 py-3 font-semibold text-sm uppercase bg-gray-800 text-white rounded-lg shadow hover:bg-gray-700">
                Get a Quote
              </button>
            </motion.div>
          </motion.div>
        </div>
      </div>
      <section className="py-10 md:py-20 font-[Roboto] w-full bg-green-50">
        {/* Section Heading */}
        <div className="max-w-6xl mx-auto text-center px-6">
          <p className="text-green-700 font-semibold tracking-wide uppercase">
            Affordable and Flexible
          </p>
          <h2 className="text-4xl font-extrabold text-green-900 mt-2">
            Choose Your Perfect Stay Package.
          </h2>
          <p className="text-green-700/80 mt-4 max-w-2xl mx-auto">
            Find the ideal eco-friendly package for your stay. Whether it’s a
            quiet escape, a family retreat, or a luxurious getaway, we have
            something sustainable for you.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto px-4 md:px-6">
          {/* Tranquil Escape */}
          <div className="bg-green-700 text-white rounded-xl shadow-xl p-8 flex flex-col hover:scale-105 transition-transform">
            <h3 className="text-2xl font-semibold">Tranquil Escape</h3>
            <p className="mt-4">
              <span className="text-4xl font-bold">$150</span>{" "}
              <span className="text-lg">Per Night</span>
            </p>
            <p className="mt-2 text-sm text-green-100">
              Perfect for solo travelers or couples looking for peace and quiet.
            </p>
            <ul className="mt-6 space-y-3 text-sm">
              {[
                "Private balcony with river view",
                "Complimentary breakfast for two",
                "Free Wi-Fi access throughout stay",
                "Welcome drinks on arrival",
                "Access to hiking trails",
                "Cozy queen-sized bed",
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 text-green-300"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
            <button className="mt-8 bg-white text-green-700 hover:bg-green-100 py-3 rounded-lg font-semibold">
              Book Now
            </button>
          </div>

          {/* Family Getaway */}
          <div className="bg-green-100 rounded-xl shadow-xl p-8 flex flex-col border border-green-200 hover:scale-105 transition-transform">
            <h3 className="text-2xl font-semibold text-green-900">
              Family Getaway
            </h3>
            <p className="mt-4">
              <span className="text-4xl font-bold text-green-700">$250</span>{" "}
              <span className="text-lg text-green-800">Per Night</span>
            </p>
            <p className="mt-2 text-sm text-green-800/80">
              Spacious and fun – designed for families to relax and enjoy
              together.
            </p>
            <ul className="mt-6 space-y-3 text-sm text-green-800">
              {[
                "Two-bedroom spacious cottage",
                "Fully equipped kitchenette",
                "Outdoor seating area",
                "Free children’s activity kits",
                "Complimentary guided nature walk",
                "Daily housekeeping service",
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 text-green-600"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
            <button className="mt-8 bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-semibold">
              Book Now
            </button>
          </div>

          {/* Luxury Retreat */}
          <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col border border-green-200 hover:scale-105 transition-transform">
            <h3 className="text-2xl font-semibold text-green-900">
              Luxury Retreat
            </h3>
            <p className="mt-4">
              <span className="text-4xl font-bold text-green-700">$350</span>{" "}
              <span className="text-lg text-green-800">Per Night</span>
            </p>
            <p className="mt-2 text-sm text-green-800/80">
              The ultimate eco-luxury experience with unmatched comfort and
              care.
            </p>
            <ul className="mt-6 space-y-3 text-sm text-green-800">
              {[
                "Exclusive villa with private pool",
                "Complimentary gourmet breakfast",
                "Dedicated personal concierge",
                "Private garden and seating area",
                "Access to luxury spa facilities",
                "Evening campfire experience",
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 text-green-600"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
            <button className="mt-8 bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-semibold">
              Book Now
            </button>
          </div>
        </div>
      </section>

      <section className="p-4 md:p-8 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-800">
              Trending Destinations
            </h2>
            <p className="text-gray-600 mt-2">
              Most popular choices for travelers
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {destinations.map((dest, index) => (
              <div
                key={index}
                className={`relative rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105
              ${index === 0 ? "md:col-span-2" : ""}`}
              >
                <img
                  src={dest.image}
                  alt={dest.name}
                  className={`w-full object-cover ${
                    index === 0 ? "h-96" : "h-64"
                  }`}
                />

                {dest.promotion && (
                  <div className="absolute top-4 right-4 bg-yellow-400 text-gray-800 text-xs font-bold px-3 py-1 rounded-full">
                    {dest.promotion} promotions
                  </div>
                )}

                {dest.countdown && index === 0 && (
                  <div className="absolute bottom-1/3 left-1/2 -translate-x-1/2 bg-black bg-opacity-50 text-white p-2 rounded-lg">
                    <span className="text-sm">Promotion will end in</span>
                    <div className="flex justify-center items-center mt-1 space-x-2">
                      <div className="text-center">
                        <div className="font-bold text-lg">
                          {dest.countdown.days}
                        </div>
                        <div className="text-xs">Days</div>
                      </div>
                      <div className="text-center">
                        <div className="font-bold text-lg">
                          {dest.countdown.hours}
                        </div>
                        <div className="text-xs">Hours</div>
                      </div>
                      <div className="text-center">
                        <div className="font-bold text-lg">
                          {dest.countdown.mins}
                        </div>
                        <div className="text-xs">Mins</div>
                      </div>
                      <div className="text-center">
                        <div className="font-bold text-lg">
                          {dest.countdown.secs}
                        </div>
                        <div className="text-xs">Secs</div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="absolute bottom-0 left-0 right-0 bg-white p-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900">
                        {dest.name}
                      </h3>
                      <p className="text-sm text-gray-600">
                        {dest.tours} Tours, {dest.activities} Activities
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="relative bg-emerald-50 py-10 md:py-20 px-4 md:px-8 lg:px-20">
        {/* Background Shape */}
        <div
          className="absolute inset-0 bg-emerald-100"
          style={{ clipPath: "polygon(0 0, 100% 0, 100% 75%, 0% 100%)" }}
        ></div>

        <div className="relative z-10 container mx-auto flex flex-col lg:flex-row items-center lg:items-start gap-12">
          {/* Left Section */}
          <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-emerald-100 px-4 py-2 rounded-full shadow-md">
                <span className="text-sm font-semibold text-emerald-800">
                  Testimonials
                </span>
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-emerald-900 leading-tight mb-4">
              What our clients are saying about us?
            </h2>
            <p className="text-emerald-700 max-w-lg mb-8 text-sm md:text-base">
              Discover how you can offset your adventure&apos;s carbon emissions
              and support sustainable initiatives practiced by our operators
              worldwide.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={prevSlide}
                className="p-3 rounded-full border border-emerald-400 text-emerald-700 hover:bg-emerald-100 transition"
              >
                <FaArrowLeft />
              </button>
              <button
                onClick={nextSlide}
                className="p-3 rounded-full border border-emerald-400 text-emerald-700 hover:bg-emerald-100 transition"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>

          {/* Right Section - Carousel */}
          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <div className="overflow-hidden w-full max-w-3xl">
              <div
                className="flex transition-transform duration-500"
                style={{
                  transform: `translateX(-${
                    currentSlide * (window.innerWidth < 768 ? 100 : 50) // 100% per slide on mobile, 50% on desktop
                  }%)`,
                }}
              >
                {testimonials.map((testimonial) => (
                  <div
                    key={testimonial.id}
                    className="w-full md:w-1/2 flex-shrink-0 p-4"
                  >
                    <div className="bg-white rounded-lg p-6 shadow-xl border border-emerald-200">
                      <div className="flex items-center mb-4">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="w-12 h-12 rounded-full mr-4 object-cover"
                        />
                        <div>
                          <h4 className="font-semibold text-emerald-900">
                            {testimonial.name}
                          </h4>
                          <p className="text-sm text-emerald-600">
                            {testimonial.location}
                          </p>
                        </div>
                        <div className="ml-auto flex text-yellow-400">
                          {Array.from({ length: 5 }, (_, i) => (
                            <FaStar
                              key={i}
                              className={
                                i < testimonial.rating
                                  ? "text-yellow-400"
                                  : "text-emerald-200"
                              }
                            />
                          ))}
                        </div>
                      </div>
                      <p className="text-emerald-800 text-sm md:text-base">
                        {testimonial.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 className="text-2xl md:text-4xl font-extrabold text-gray-700 mt-5 text-center">
        Latest Blogs
      </h2>
      <BlogArticle />
    </Layout>
  );
};

export default HomePage;
